export default {
    van: {
        name: '名称',
        confirm: '确认',
        cancel: '取消',
    },
    app: {
        confirm: '确定',
        cancel: '取消',
        skip: '跳过',
        request: {
            error_info: '错误信息',
            copy: '复制'
        },
        message: {
            hello: '你好,世界',
        },

        home: {
            search_area: '经销商地区',
            search_area_content: '经销商地址',
            gotothis: '到这去',
            area_select: '选择地址',


            selfplace: '当前位置',


            dealerfullname: '经销商名称',
            dealeraddress: '经销商地址',
            map_store_query_title: '门店查询',
            map_store_location_fallback_hint: '(当前定位权限未允许,使用默认地址)',
            map_store_select_province: '选择省份',
            map_store_search_province_placeholder: '搜索省份',
            map_store_search_store_placeholder: '搜索门店名称',
            map_store_search_store_or_code_placeholder: '搜索省份/门店名称',
            map_store_empty_line1: '该省份暂无门店',
            map_store_empty_line2: '您可搜索其他省份门店',
            map_store_empty_area_line1: '该区域暂无门店',
            map_store_empty_area_line2: '您可搜索其他区域门店',
            map_store_nav_button: '导航',
            map_store_overview_button: '整体预览',
            map_store_refresh_button: '刷新门店',
            map_store_all_provinces: '全部省份',
            map_country_china: '中国',
            map_country_malaysia: '马来西亚',
            map_region_label: '区域',
            map_loading: '地图加载中...',
            map_region_switch_loading: '当前正在加载，请稍候再切换国家',
            map_popup_auth_date_prefix: '授权日期：',
            map_popup_distance_prefix: '距离：',
            map_popup_nav_to: '导航前往',
            map_popup_copy_address: '复制',
            map_nav_getting_location: '正在获取定位…',
            map_nav_location_unavailable_title: '无法获取当前位置',
            map_nav_location_unavailable_message:
                '无法获取当前定位，是否继续导航？您可在地图中自行输入起点。',
            map_nav_continue: '继续导航',
            map_nav_cancel: '取消',
            map_nav_popup_blocked_title: '新窗口被拦截',
            map_nav_popup_blocked_message:
                '浏览器拦截了新窗口。请点击下方按钮打开导航，您将停留在当前地图页面。',
            map_nav_popup_blocked_open: '打开导航',
            map_nav_popup_blocked_open_current_message:
                '仍无法打开新窗口，是否在当前页打开导航？将离开当前地图页面。',
            map_nav_popup_blocked_open_current: '在当前页打开',
            map_nav_wechat_browser_title: '请在浏览器中打开',
            map_nav_wechat_browser_message_ios:
                '微信内无法直接唤起地图 App。请点击右上角「···」，选择「在 Safari 中打开」后，再次点击导航。',
            map_nav_wechat_browser_message_android:
                '微信内无法直接唤起地图 App。请点击右上角「···」，选择「在浏览器中打开」后，再次点击导航。',
            map_nav_wechat_browser_confirm: '我知道了',
            map_nav_ios_map_apple: 'Apple 地图',
            map_nav_ios_map_google: 'Google 地图',
            map_nav_ios_map_picker_title: '选择导航应用',
            map_geo_unsupported: '当前浏览器不支持定位',
            map_geo_failed: '定位失败',
            map_geo_permission_denied: '定位权限被拒绝',
            map_geo_unavailable: '暂时无法获取位置',
            map_geo_timeout: '定位超时',

            map_popup_location_error: '门店位置异常',
            map_geolocation_watchdog_timeout: '定位超时，已使用默认区域',

        },

        scheme: {
            nomoredata: '没有更多了',
            author: '作者',
        },
        schemedetail: {
            errordata: '数据异常',
        },

        login: {
            user_type: '用户类型',
            user_type_placeholder: '请选择用户类型',
            phone: '手机号',
            phone_placeholder: '请输入手机号',
            code: '短信验证码',
            code_placeholder: '短信验证码',
            send_code: '发送验证码',
            login: '登录',
            phone_verify: '请输入正确的手机号',
            imagecode_verify: '请输入图形验证码',
            send_code_finish: '验证码已发送',
            code_count: 's后重发',
            login_success: '登录成功',

            user_type_person: '个人',
            user_type_dealer: '经销商',

            captcha: '图形验证码',
            captcha_placeholder: '图形验证码',

            user_registe: '用户注册',
            dealer_user_registe: '经销商用户注册',
            dealer_registe: '经销商注册',


            gotoregister: '请先注册',




            selectaccount: '选择账号',


            roleregister: "注册",

            input_sms_code: '请输入短信验证码',
            quick_register_title: '完善资料，完成注册',
            quick_register_subtitle: '该手机号尚未注册\n设置用户名即可快速注册登录',
            quick_register_name_label: '用户名',
            quick_register_name_placeholder: '请输入用户名',
            quick_register_name_required: '请先填写用户名',
            quick_register_confirm: '注册并登录'


        },

        // 经销商注册
        dealerregister: {
            dealer_register: '分销商注册',
            dealerType: '经销商',
            dealerAddress: '地区选择',
            dealerFullAddress: '经销商地址',
            dealerName: '经销商全称',
            dealerShortName: '经销商简称',
            dealerNamePlaceHolder: '请输入经销商名称',
            userName: '联系人姓名',
            userEmail: '联系人邮箱',
            userPhone: '联系人手机号',
            phone: '手机号',
            imageCode: '图形验证码',
            register: '注册',
            login: '已有账户去登录',



            dealerBrand: '经销商品牌',
            dealerSuperiorName: '上级分销商',
            dealerSuperiorNamePlaceHolder: '如无上级分销商请忽略',


            tips: '*提交注册信息后,需要进行审核和批准.\n(根据情况,由我们的工作人员进行在线审核或现场审核.)',

            oemdealer: 'OEM',
            dealer: '分销商',
            channel: '仅渠道',
            // dealershop: '经销门店'

            business_license: '营业执照',
            business_registration_certificate: '商业登记证',

            business_license_code: '统一社会信用代码',
            business_registration_certificate_code: '商业登记号码',



        },



        // 经销商用户注册
        dealeruserregister: {

            dealer_user_register: '经销商用户注册',
            dealerType: '经销商',
            dealerTypePlaceHolder: '请选择经销商',

            userName: '姓名',
            userNamePlaceHolder: '请输入姓名',

            userEmail: '邮箱',
            userEmailPlaceHolder: '请输入邮箱',

            userPhone: '手机号',
            userPhonePlaceHolder: '请输入手机号',

            imageCode: '图形验证码',

            register: '注册',
            dealerRegister: '注册经销商',
            login: '已有账户去登录',


            dealerTypeSelectTips: '没有经销商,请先注册经销商'

        },

        // 用户注册
        userregister: {
            user_register: '用户注册',
            userName: '姓名',
            userNamePlaceHolder: '请输入姓名',
            userEmail: '邮箱',
            userEmailPlaceHolder: '请输入邮箱',

            userPhone: '手机号',
            userPhonePlaceHolder: '请输入手机号',

            imageCode: '图形验证码',
            register: '注册',
            login: '已有账号去登陆',

            register_success: '注册成功',

        },


        qa: {
            // 质保创建
            qaform: {
                carinfo: '车辆信息',
                brand: '车品牌',
                brandPlaceHolder: '车品牌',
                carstyle: '车型',
                carstylePlaceHolder: '车型',
                carNo: '车牌号',
                carNoPlaceHolder: '车牌号',
                carCjNo: '车架号',
                carCjNoPlaceHolder: '车架号',
                carOwnerName: '车主姓名',
                carOwnerNamePlaceHolder: '车主姓名',
                phoneNumber: '手机号',
                phoneNumberPlaceHolder: '手机号',
                ownerphoneNumberPlaceHolder: '车主手机号',



                productinfo: '产品信息',
                productName: '产品',
                productNamePlaceHolder: '产品',

                productNo: '卷号',
                productNoPlaceHolder: '卷号',

                productExpire: '质保',
                productExpirePlaceHolder: '质保',

                scanProductInfo: '扫码获取产品信息',



                doForminfo: '装贴信息',
                doDate: '日期',
                doValidDate: '装贴日期',
                doDatePlaceHolder: '点击选择日期',
                getProductInfo: '请先获取产品信息',
                fullcar: '全选',
                doCarShop: '门店',
                doCarShopPlaceHolder: '点击选择门店',
                doPrice: '价格',
                doPricePlaceHolder: '请输入实际成交金额',


                qacarcontent: '质保内容',



                qacarimage: '装贴照片',
                qacarzhengmian: '正面施工照',
                qacarcemian: '侧面施工照',
                qacarbeimian: '背面施工照',
                qacarshop: '车辆与店招图',
                qacarjuanhao: '清晰卷号图',
                qacarjuanhaoandcar: '卷号和车辆照',
                submit: '提交',


                qaformsuccess: '创建成功',


                imagemustsix: '图片请上传六张',

                productinfo_first: '(请先扫码获取产品信息)',


                warranty_days: '天',
                warranty_year: '年',


                contact_customer_service: '联系客服',

                contact_customer_service_wechat: '微信客服',
                contact_customer_service_wechat_click: '点击联系人工客服',


                contact_customer_service_phone: '电话客服',
            },

            // 质保搜索
            qasearch: {
                searchcontent: '通过手机号搜索质保卡',
                phone: '手机号',
                phonePlaceHolder: '请输入手机号',
                imageCode: '图形验证码',
                imageCodePlaceHolder: '图形验证码',
                search: '搜索',
                qalist: '质保列表',

                noqatips: '当前手机号暂无质保',

            },
            // 质保审核
            qareview: {
                reviewtab: '未审核',
                reviewing: '审核中',
                success: '已审核',
                failed: '已驳回',

                submitsuccess: '提交成功',
                submit: '提交',


                reviewsuccess: '审核通过',
                reviewfailed: '审核拒绝',
                review: '审核',


                dateStart: '日期从',
                dateEnd: '日期到',

                searchtips: '模糊搜索',
                searchtipsPlaceHolder: '请输入关键词',



                search: '搜索',


                reject_reason: '拒绝理由',
                reject_reason_placeholder: '请输入拒绝理由'



            },

            // 质保详情
            qadetail: {
                carinfo: '车辆信息',
                brand: '车品牌',
                carstyle: '车型',
                carNo: '车牌号',
                carCjNo: '车架号',
                carOwnerName: '车主姓名',
                phoneNumber: '手机号',
                productinfo: '产品信息',
                productName: '产品',
                productNo: '卷号',
                productExpire: '质保',
                doForminfo: '装贴信息',
                doDate: '日期',
                doPart: '装贴部位',
                doCarShop: '门店',
                doPrice: '价格',
                qacarcontent: '质保内容',
                qacarimage: '装贴照片',
                qacarzhengmian: '正面施工照',
                qacarcemian: '侧面施工照',
                qacarbeimian: '背面施工照',
                qacarshop: '车辆与店招图',
                qacarjuanhao: '清晰卷号图',
                qacarjuanhaoandcar: '卷号和车辆照',

            },



            qaitem: {
                id: '质保卡ID',
                warrantyCode: '质保编码',
                starttime: '质保开始日期',
                createtime: '质保创建日期',
                car: '汽车',
                product: '产品',


                status_not_confired: '未确认',
                status_confirming: '确认中',
                status_confirmed: '已确认',
                status_rejected: '已驳回'




            }
        },

        // 库存相关
        stock: {
            stockin: '库存中',
            stockrecord: '库存',
            stockused: '已出库',
            stockunin: '待入库',





            stockinsuccess: '入库成功',
            stockoutsuccess: '出库成功',


            stockscancode: '扫码入库',
            stockrecord: '入库记录',



            stockid: '库存ID',



            stock_stock_in: '入库',
            stock_stock_out: '出库',


        },

        // 多语言切换界面
        language: {
            btn_complete: '完成',
            switch_label: '语言切换',
            simplified: '简体中文',
            traditional: '繁體中文',
            english: 'English',
            malay: 'Bahasa Melayu',
        },

        mine: {
            username: '用户名',
            changerole: '切换角色',

            changerolddesc: '是否要切换角色',

            norolecanchagen: '没有角色可切换'
        },

        // 我的页面的ITEM 选项
        mineitem: {
            myqaitem: '我的质保',
            mysecuritycheckitem: '序列号校验',
            myshopitem: '我的采购计划',
            mystockitem: '库存管理',
            mygoodsitem: '发货管理',
            myqareviewitem: '质保管理',
            mydealermanageritem: '分销商/零售商管理',
            myconstructionitem: '施工管理',
            mycouponitem: '我的券码',
            couponmanageitem: '券码管理',
            mycouponcheckitem: '券码核销',
            mycouponreportitem: '券码报表',
            myinstructionitem: '说明书',
            mylanguageitem: '语言切换',
            mychartqaitem: '质保报表',
            mychartpurchaseorderitem: '采购单报表',
            workerlist: '员工管理',
            workerdetail: '员工信息',

            mystockinitem: '入库管理',
            mycreatestockitem: '创建库存',
            mystockoutitem: '出库管理',
            mycreateqaitem: '创建质保',
            myqueryqaitem: '质保查询',
            myclaimitem: '索赔',
            myclaimapprovalitem: '索赔审批',
            mycompensationitem: '赔付管理',
            myorderitem: '下级采购计划管理',
            mylogout: '退出登录',
            myloginin: '登录',

            mypaymentorderitem: '采购下单',
            mypaymentordermanageritem: '采购订单管理',
            mypaymentorderbillmanageritem: '付款单管理',
            myproductpurchaseitem: '商品购买',
            wechat_purchase_hint: '微信内无法直接唤起支付宝，可点击右上角「···」选择「在浏览器打开」后选择商品进行支付',


            myservicecentermanager: '服务网点管理',
            addressmanager: '地址管理',
            warehousemanager: '仓库管理',
            reportmanager: '经营报表',
            storemanager: '店铺管理',

            myservicepurchase: '服务购买',
        },

        // 导航相关
        nav: {
            qalist: '质保列表',
            qacreate: '质保创建',
            securitycheck: '序列号校验',
            qadetail: '质保详情',
            showlist: '采购列表',
            showorderlist: '交易列表',
            storelist: '店铺列表',
            showorder: '采购下单',
            shopdetail: '采购详情',
            shoporderdetail: '交易详情',
            stock: '库存管理',
            stockin: '入库管理',
            stockout: '出库管理',
            purchase: '发货管理',
            purchasedetail: '发货详情',
            qareview: '质保管理',
            dealershopmanager: '分销商/零售商管理',
            dealershopmanagerdetail: '详情',
            qasearch: '质保搜索',
            qapublicquery: '汽车膜质保查询',
            register: '注册',
            scancode: '扫码',
            detail: '详情',
            languagechange: '语言切换',
            storecreate: '门店创建',
            dealercreate: '经销商创建',
            construction: '施工管理',
            construction_pending: '待施工',
            construction_completed: '施工完成',
            construction_accepted: '施工验收',
            construction_detail: '施工详情',
            coupon: '我的券码',
            coupon_manage: '券码管理',
            coupon_detail: '券码详情',
            coupon_check: '券码核销',
            charts_coupon: '券码报表',
            manual: '说明书',
            charts_qa: '质保报表',
            charts_po: '采购单报表',
            charts_inoutstock: '出入库报表',

            role_select: '选择身份',
            dealer_register: '分销商注册',
            direct_vender_register: '直营商注册',
            dealer_shop_register: '零售商注册',
            service_provider_register: '服务商注册',
            register_address_map: '选择具体地址',

            dealer_worker_register: '分销商员工注册',
            service_worker_register: '服务商员工注册',
            shop_worker_register: '零售商员工注册',
            consumer_user_register: '用户注册',

            qrcode_register: '扫码注册',

            workerlist: '员工管理',
            workerdetail: '员工信息',


            purchase_order: '订单管理',
            purchase_order_detail: '订单详情',
            in_stock_detail: '入库详情',
            paymentorderbill: '付款单列表',
            paymentorderbilldetail: '付款单详情',

            scandetail: '扫码详情',
            stockoutdetail: '出库详情',
            stockindetail: '入库详情',
            stockstockdetail: '库存详情',


            servicecentermanager: '服务网点管理',
            servicecentercreate: '服务网点创建',
            servicecenterdetail: '服务网点信息',

            addressmanager: '地址管理',
            addresscreate: '创建地址',
            addressdetail: '详情',

            warehousemanager: '仓库管理',
            warehousecreate: '创建仓库',

            ordersummary: '订单汇总',

            orderproductout: '发货管理',

            chartslist: '经营报表',
            servicepurchase: '服务购买',

            paysuccess: '支付成功',

            servicelistmanager: '服务订单管理',

            consumer_order_detail: '订单详情',
            consumer_order_list: '订单管理',
            consumer_order_info: '订单详情',
            consumer_payment_bill_list: '付款单管理',
            consumer_payment_bill_info: '付款单详情',
            consumer_store_list: '选择店铺',
            consumer_shop: '选择商品',

            claimlist: '索赔列表',
            claimapply: '索赔申请',
            claimdetail: '索赔详情',
            claimapproval: '索赔审批',
            claimapprovaldetail: '审批详情',
            compensation: '赔付管理',
            compensationdetail: '赔付详情'
        },

        // 索赔详情
        claimdetail: {
            claimstatus: '索赔状态',
            statuspending: '待审核',
            statusapproved: '已审核',
            statusrejected: '已驳回',
            loading: '加载中…',
            applytime: '申请时间',
            approval_time: '审核时间',
            approval_opinion: '审核意见',
            productinfo: '产品信息',
            productname: '产品名称',
            product_category: '产品类目',
            serialnumber: '卷号',
            compensation_party: '赔付方信息',
            compensation_type: '赔付方类型',
            compensation_name: '赔付方名称',
            warranty_info: '关联质保',
            warranty_code: '质保编号',
            valid_period: '有效期',
            phone: '手机号',
            questionnaire: '问卷信息',
            media: '图片与视频',
            notfound: '未找到该索赔记录',
            video_load_failed: '视频加载失败，请稍后重试'
        },

        // 索赔审批
        claimapproval: {
            all: '全部',
            pending: '待审核',
            approved: '已审核',
            rejected: '已驳回',
            id: 'ID',
            product_name: '产品名称',
            serial_number: '卷号',
            claim_party: '索赔方',
            warranty_code: '质保编号',
            empty: '暂无{label}记录',
            emptyall: '暂无记录',
            viewdetail: '点击查看详情并审批'
        },

        // 索赔审批详情
        claimapprovaldetail: {
            flow_submitted: '已提交',
            claim_party_info: '索赔方信息',
            claim_party: '索赔方',
            approve: '通过',
            reject: '驳回',
            approve_title: '通过申请',
            approve_placeholder: '请填写通过原因…',
            approve_required: '请填写通过原因',
            reject_title: '驳回申请',
            reject_placeholder: '请填写驳回原因…',
            reject_confirm: '确认驳回',
            cancel: '取消',
            approve_confirm: '确认通过',
            reject_required: '请填写驳回原因',
            approve_success: '已通过',
            reject_success: '已驳回',
            operate_failed: '操作失败，请稍后重试'
        },

        // 索赔申请
        claimapply: {
            claim_type: '索赔类型',
            link_warranty: '关联质保',
            product_no: '商品卷号',
            product_info: '产品信息',
            questionnaire: '问卷信息',
            required_select: '必选',
            required_fill: '必填',
            type_warranty: '质保关联',
            type_product: '商品索赔',
            select_warranty_placeholder: '选择质保记录',
            manual_input: '手动输入',
            scan_input: '扫码获取',
            product_no_placeholder: '请输入卷号',
            verify: '验证',
            scan_hint: '点击扫码获取卷号',
            product_category: '产品类目',
            product_name: '产品名称',
            serial_number: '卷号',
            compensation_party: '赔付方信息',
            compensation_type: '赔付方类型',
            compensation_name: '赔付方名称',
            input_placeholder: '请输入',
            file_type_image: '图片',
            file_type_video: '视频',
            multi_select_hint: '(可多选)',
            check_questionnaire: '请检查问卷内容是否填写正确',
            submit: '提交索赔',
            select_warranty: '选择质保',
            close: '关闭',
            loading: '加载中…',
            warranty_code: '质保编号',
            valid_period: '有效期',
            product: '产品',
            phone: '电话',
            vin: '车架号',
            warranty_empty: '未找到匹配的质保记录',
            file_min: '最少 {n} 个',
            file_max: '最多 {n} 个',
            file_range: '最少 {min} 个，最多 {max} 个',
            error_required: '此项为必填项',
            error_length: '字数需在 {min}~{max} 之间',
            error_number: '数值需在 {min}~{max} 之间',
            error_format: '格式不正确',
            error_file_min: '至少上传 {n} 个文件',
            error_file_max: '最多上传 {n} 个文件',
            toast_select_claim_type: '请选择索赔类型',
            toast_select_warranty: '请选择关联的质保记录',
            toast_product_no: '请输入或扫码获取商品卷号',
            toast_verify_failed: '卷号校验失败',
            toast_verify_success: '验证成功',
            toast_submit_success: '索赔申请已提交',
            toast_submit_failed: '提交失败，请稍后重试'
        },

        // 索赔列表
        claimlist: {
            all: '全部',
            pending: '待审核',
            approved: '已审核',
            rejected: '已驳回',
            serial_number: '卷号',
            compensation_party: '赔付方',
            warranty_code: '质保编号',
            approval_opinion: '审核意见',
            id: 'ID',
            product_name: '产品名称',
            empty: '暂无{label}记录',
            emptyall: '暂无记录',
            empty_sub: '遇到产品不良问题，可发起索赔申请',
            create: '发起索赔'
        },


        // 消费者扫码订单（个人消费者）
        consumerorder: {
            order_no: '订单号',
            product_list: '商品清单',
            product_amount: '商品金额',
            freight: '运费',
            freight_free: '免运费',
            total_amount: '合计',
            pay_amount: '应付金额',
            create_order: '创建订单',
            create_payment: '创建付款单',
            first_select_address: '请先选择收货地址',
            order_success: '下单成功',
            go_to_payment: '是否现在支付？',
            payment_confirm: '去支付',
            payment_back: '稍后',
            payment_method: '支付方式',
            payment_success: '支付成功',
            payment_failed: '支付发起失败，请稍后重试',
            alipay_querying: '正在查询支付结果，请稍候…',
            alipay_back: '返回',
            alipay_scan_tip: '请使用支付宝扫码支付',
            alipay_scan_sub: '支付完成后将自动检测',
            company_name: '公司名称',
            bank_name: '开户行',
            bank_account: '银行账号',
            payment_time: '付款时间',
            payment_time_now: '当前时间',
            payment_time_manual: '手动调整',
            select_full_date: '选择完整时间',
            search_order_placeholder: '请输入订单ID查询',
            tab_all: '全部',
            tab_unpay: '待付款',
            tab_unconfirmed: '待确认',
            tab_partpay: '部分付款',
            tab_payed: '已确认',
            tab_confirmed: '已确认',
            tab_closed: '已关闭',
            status_confirmed: '已确认',
            status_pending_payment: '待付款',
            status_confirming: '待确认',
            payment_bill_manage: '付款单管理',
            search_bill_placeholder: '请输入付款单ID查询',
            payment_bill_id: '付款单ID',
            transaction_no: '交易流水号',
            payment_subject_type: '付款主体类型',
            payment_subject: '付款主体',
            receive_account: '收款账户',
            payment_amount: '付款金额',
            order_id: '订单ID',
            order_person: '下单人',
            order_date: '下单时间',
            order_info: '订单信息',
            order_status: '订单状态',
            order_time: '下单时间',
            price_detail: '金额明细',
            really_pay: '实付金额',
            order_payment: '付款单信息',
            related_order: '关联订单',
            create_pay_time: '创建时间',
            payment_date: '付款时间',
            confirm_date: '确认时间',
            loading: '加载中…',
            empty: '暂无相关订单',
            empty_hint: '换个状态看看，或扫码下单',
            retailer: '零售商',
            retailer_id: '零售商ID',
            includes: '包含',
            logistics_need: '需物流',
            logistics_none: '无需物流',
            logistics_optional: '可选物流',
            delivery_title: '收货方式',
            delivery_need: '需要寄送',
            delivery_none: '不需要寄送',
            no_delivery_hint: '本单无需寄送',
            no_delivery_desc: '无需填写收货地址，可直接创建订单',
            leave_confirm: '离开后需重新扫码进入本页',
            leave_confirm_ok: '确认离开',
            leave_confirm_cancel: '留在本页',
            consumer_only_hint: '本页面仅供个人消费者使用，当前账号无法访问',
            consumer_only_confirm: '确定',
            data_error: '数据异常',
            retailer_select_title: '选择零售商',
            retailer_placeholder: '请选择零售商',
            retailer_search_placeholder: '搜索门店名称',
            retailer_locating: '正在获取定位…',
            retailer_empty: '未找到相关零售商',
            shop_search_placeholder: '搜索店铺名称',
            shop_empty: '未找到相关店铺',
            empty_product: '暂无商品',
            retailer_required: '请先选择零售商',
            retailer_change: '更换',
            alipay_wechat_guide_title: '请到浏览器中打开完成支付',
            alipay_wechat_guide_desc: '微信内无法直接唤起支付宝，按下面步骤操作即可',
            alipay_wechat_guide_step1: '点击右上角「···」',
            alipay_wechat_guide_step2: '选择「在浏览器打开」',
            alipay_wechat_guide_step3: '重新点击「去支付」完成付款',
            alipay_wechat_pay_message:
                '微信内无法直接唤起支付宝，可点击右上角「···」选择「在浏览器打开」后重新支付，或改用银行卡支付。',
            alipay_wechat_pay_confirm: '我知道了'
        },


        // 购物相关
        shop: {
            order: '下单',
            clearcart: '清空购物车',
            selectall: '全选',

            addCart: '请先选择规格',
            shopsuccess: '下单成功',

            addToCartFirst: '请先加入购物车',



            shoplistid: '采购单ID',
            showlisttime: '采购日期',
            showlistdealer: '经销商',
            showlistphone: '采购人手机号',



            getshop: '采购',

            addToCart: '加入购物车',
            product_detail: '商品详情',
            no_detail: '暂无详情',
            view_detail: '查看详情',


            allproduct: '数量',
            allprice: '总计',




            order_status_unreview: '核款中',


            price_begin: '起',



            nopermission: '非代理商用户无权查看商品信息',


            popup_confirm: '回到官网',
            popup_changerole: '切换角色',

            purchase_people: '采购人',

            purchase_from: '采购商',


            confirm_order: '确认下单'



        },



        account: {
            title: '汇款账户信息',
            companynametitle: '公司名称',
            companynamevalue: '上海广台乔子实业发展有限公司',

            tintitle: '纳税人识别号',
            tinvalue: '91310118560192303A',

            addresstitle: '地址',
            addressvalue: '青浦区朱家角镇祥凝浜路16弄45号320室',

            phonetitle: '电话',
            phonevalue: '64188908',

            banktitle: '开户银行',
            bankvalue: '农业银行上海威海路支行',

            accounttitle: '汇款帐号',
            accountvalue: '03304700040011734',

            merchantnotitle: '商户号',
            parentmerchantnotitle: '平台商户号',
            nopaymentmethod: '暂无付款方式',
            alipay: '支付宝',
            banktransfer: '银行转账',


            tips: '*下单以后,汇款账户信息在采购详情页面可查'


        },




        // 发货相关
        purchase: {
            dateStart: '日期从',
            dateEnd: '日期到',
            searchtips: '模糊搜索',
            searchtipsPlaceHolder: '请输入关键词',
            search: '搜索',
            unpurchase: '未发货',
            purchased: '已发货',


            scanstockout: '扫码出库',


            id: '采购单ID',
            time: '采购时间',
            dealer: '采购经销商',
            dealerphonenumber: '采购用户手机号',


            dealername: '经销商名称',
            dealeraddress: '经销商地址',
            dealercontactname: '联系人姓名',
            dealercontactphone: '联系人手机号',


            dealerinfo: '经销商信息',
            productinfo: '产品信息',


            gopurchase: '采购',

            search_input_purchase_placeholder: '请输入采购单ID查询',


            purchase_list: '采购列表',

            to_now: '至今',


        },


        purchasedetail: {
            goodsinfo: '商品信息',

            bankinfo: '汇款信息',
        },


        // resultsuccess: '正品无误\n\n恭喜您,该产品为嘉实多汽车膜产品正品',
        // resulterror: '假冒商品\n\n请联系官方处理',
        // 防伪相关 
        securitycheck: {
            securitycheckscancode: '扫码查真伪',
            productscan: '产品序列号',
            resultsuccess: '正品无误',
            resulterror: '假冒商品',
            resulterrortwo: '暂未查询到该序列号',
            resulterrordetail: '系统当前无法匹配您输入的序列号,建议您联络您的零售商或联系上级分销商进行人工核对,以获取详细的产品反馈.',


            tips: '注册电子质保后享有官方质保及不同增值服务',
            // topthanks: '恭喜您,该产品为嘉实多汽车膜产品正品',
            thanks: '恭喜您,该产品为嘉实多汽车膜产品正品\n感谢您的支持!',
            thankserror: '请联系官方处理',
            thankserrortwo: '系统当前无法匹配您输入的序列号\n建议您联络您的零售商或联系上级分销商进行人工核对,以获取详细的产品反馈.',
            jump: '跳转',

            productverify: '产品真伪验证',
            productstyle: '产品型号',
            expire: '质保期限',

            qacreate: '创建质保'


        },


        // 扫码相关 
        qrcode: {
            cameraname: '摄像头',
            selectcamera: '选择摄像头',
            tips: '扫码有问题?点击切换摄像头',
            btntips: '切换',


            fromalbum: '从相册选择',
            imageverifyerror: '图片识别失败',
            initerror: '解析器初始化失败',


            changecamera: '切换摄像头',
            album: '相册',
            scan_end: '结束扫码',
            scan_preview: '扫码预览',
            scan_summary: '扫码汇总',


            scan_success: '扫码成功',
            please_scan_first: '请先扫码',

            barcodetips: '请将条形码对准框内进行扫描',


            verify_success: '校验成功'


        },

        //经销商/门店管理 
        dealershopmanager: {
            dealername: '分销商',
            shopname: '门店',
            retailer: '零售商',

            item: {
                id: 'ID',
                fullname: '全称',
                address: '地址',
            },
            detail: {
                id: 'ID',
                fullname: '全称',
                address: '地址',
                shortname: '简称',
                brand: '品牌',
                level: '级别',
                createtime: '创建时间'
            },
            createshop: '创建门店',
            createdealer: '创建分销商',
            createretailer: '创建零售商',
            search_name: '请输入名称搜索',

            type: {
                picker_title: '选择零售商类型',
                picker_subtitle: '请选择要创建的零售商类型',
                retailer: '普通零售商',
                retailer_desc: '具备销售与施工能力',
                sales_only: '仅销售零售商(N 店)',
                sales_only_desc: '仅负责销售，不参与施工',
                sales_only_short: '仅销售',
                cancel: '取消'
            },

            shop: {
                title: '门店详情',
                shopinfo: '门店信息',
                shopname: '门店简称',
                shopfullname: '门店全称',
                shopaddress: '门店地址',
                shopphonenumber: '联系人手机号',
                submit: '提交',
                verifyone: '营业执照',

                dealerfullname: '经销商全称',
                dealerlevel: '经销商级别',


                verifyonefront: '文件',
                verifyoneback: '文件',
                verifyoneshopimg: '文件',

                emptytips: '资料填写不全',

                submitsuccess: '资料提交成功,审核中......',


                storeaddress: '门店地址',







            },
            dealer: {
                dealerinfo: '经销商信息',
                title: '经销商详情',
                submit: '提交',
                nomoreimages: '最多上传三张照片',
                submitsuccess: '资料提交成功,审核中......'


            },
            tips: '*提交创建信息后,需要进行审核和批准.\n(根据情况,由我们的工作人员进行在线审核或现场审核.)',


            businessLicenseNumber: '营业执照号码',


        },

        // 施工单
        construction: {
            order_available: '可接单',
            order_pending_construction: '待施工',
            order_under_construction: '施工中',
            order_construction_completed: '施工完成',
            order_accepted: '已验收',
            order_cancelled: '已取消',


            accepted: '验收',




            item: {
                order_id: '订单号',
                color: '颜色',
                car_style: '车型',
                dealer: '经销商',
                construction_address: '施工地址',
                construction_time_area: '施工时间范围',
                selected_construction_time: '已选施工时间',
                construction_people: '施工人员',


                under_construction_btn_before: '提前施工',
                under_construction_btn_after: '开始施工',



            },

            // 待施工 
            pedding_construction: {

                title: '是否开始施工',
                cancel: '取消',
                confirm: '确定',

            },


            // 施工完成详情
            constructioncompleted_detail: {
                title: '请上传施工后车辆照片',
                image: '图片',
                cell_title: '交接车检测项目',
                defect_name: '缺陷名称',
                bubble: '气泡',
                impurity: '杂质',
                offset_printing: '胶印',
                indicates_scratch: '表明刮伤',
                surface_wrinkle: '表面褶皱',
                surface_damage: '表面破损',
                warranty_upload: '质保上传',
                construction_completed: '施工完成',
                pedding_construction_accepted: '等待车主验车',
                before_completed_tips: '请先上传签字验收单图片',
                cancel: '取消',
                confirm: '确定',

            },

            // 施工验收详情
            constructionaccepted_detail: {
                cell_title: '交接车检测项目',
                defect_name: '缺陷名称',
                bubble: '气泡',
                impurity: '杂质',
                offset_printing: '胶印',
                indicates_scratch: '表明刮伤',
                surface_wrinkle: '表面褶皱',
                surface_damage: '表面破损',
                warranty_upload: '质保上传',

                images_title: '施工后照片',

                accepted: '验收',
                construction_completed: '施工完成',
                before_completed_tips: '请上传施工后车辆照片',

                pedding_construction_accepted: '是否验收通过',
                cancel: '取消',
                confirm: '验收通过',


                completed_photos: '施工完成照片',

                owner_qrcode_photos: '车主验收二维码',
            },


            // 施工项 详情
            construction_detail: {
                title: '施工单详情',

                order_id: '订单号',
                color: '颜色',
                car_style: '车型',
                construction_time_area: '施工时间范围',
                construction_address: '施工地址',
                selected_construction_time: '选定施工时间',
                salespeople_phonenumber: '销售人员手机号',
                owner_phonenumber: '车主手机号',
                worker: '施工人员',
                construction_part: '施工部位',
                comment: '评论',




                images_title: '施工完成照片',

                owner_images_title: '施工验收照片',

            }
        },

        // 我的券码
        coupon: {
            nav: {
                unused: '待使用',
                used: '已使用',
                invalid: '已失效',

                dealer_unused: '已发放',
                dealer_used: '已核销',
                dealer_invalid: '已失效'
            },

            detail: {
                id: 'ID',
                verificationcode: '核销码',
                name: '优惠券',
                phone: '用户手机号',
                store: '适用门店',
                usedstore: '使用门店',
                date: '适用日期',
                state: '状态',
                check_time: '核销时间',
                detail: '详情',
                qrcode_title: '核销二维码'
            },

            // 券码核销
            check: {
                securitycheckscancode: '券码核销',
                productscanstate: '核销状态',
                coupon_id: '券码ID',
                coupon_verificationcode: '券码核销码',
                coupon_name: '券码名称',
                coupon_address: '使用地点',
                coupon_scan_date: '核销时间',

                coupon_check_yes: '核销成功',
                coupon_check_no: '核销失败',

                nav_check: '券码核销',
                nav_list: '核销记录',
            },

        },


        // mainbody 相关
        mainbody: {
            dealername: {
                top_title: '请输入您要注册的商户/公司全称',
                tips: '*请仔细填写确保名称和营业执照一致',
                label: '商户/公司全称',
                bottom_content: '下一步',
            },
            dealer: {
                toptitle: '请填写商户/公司资料',
                dealertype: '类型',
                fullname: '商户/公司全称',
                filetype: '证件类型',
                filetype_placeholder: '统一社会信用代码',
                file_image: '证件照片',
                bottom_content: '下一步',
                select_region_first: '请先选择国家/省/市/区',
                region_label: '已选地区',
                locate_on_map: '定位',
                drag_marker_hint: '输入具体地址后点击定位；若位置不准，可拖动地图标记微调',
                locate_building_approximate: '已定位到小区范围，天地图暂无该楼栋精确坐标，请拖动标记到具体楼栋',
                longitude: '经度',
                latitude: '纬度',
                confirm_address: '确定地址',
                enter_detail_address: '请输入具体地址',
                locate_failed: '地址定位失败，请检查地址或手动拖动标记',
                confirm_address_invalid: '请先输入具体地址并在地图上确认位置',
                detail_address_title: '请输入具体地址',
                detail_address_subtitle: '建议填写到楼栋/门牌；楼层室号不影响定位，可手动拖动标记微调',
                map_placeholder: '请先输入具体地址并点击「定位」，地图将在此显示',
                map_style_streets: '标准',
                map_style_hybrid: '卫星',
                map_switched_satellite: '乡村地区已切换卫星地图，可查看实际地貌',
                map_panel_tianditu: '天地图选点',
                map_panel_maptiler: 'MapTiler',
                map_panel_maptiler_compare: 'MapTiler 对比（只读）',
                map_compare_hint: '临时双地图对比 · 以天地图坐标为准 · 拖动天地图标记后 MapTiler 同步显示',
                geocode_result_title: '定位结果',
                geocode_input_address: '输入地址',
                geocode_matched_address: '匹配地址',
                geocode_source: '解析来源',
                geocode_coord_system: '坐标系',
                geocode_lnglat_pair: 'lng,lat',
                geocode_level: '精度级别',
                geocode_manual_adjusted: '已手动调整',
                geocode_approximate: '近似定位',
                geocode_copy_lnglat: '复制坐标',
                geocode_copy_success: '坐标已复制',
                geocode_source_tianditu: '天地图',
                geocode_source_maptiler: 'MapTiler',
            },
            dealeruser: {
                toptitle: '请填写联系人资料',
                desc: '即可完成注册',
                fill_real_name: '请填写真实姓名',
                fill_fake_name: '请填写用户名',
                fill_captcha: '请输入图形验证码',
                fill_sms_code: '请输入短信验证码',
                register: '注册',
            },
            directvendor: {
                top_title: '请输入您要注册的直营商全称',
                label: '直营商全称',
            },


        },

        roleselect: {
            title: '感谢您选择嘉实多',
            desc: '请选择您要注册的身份',

            topdealer: '一级分销商',
            directvendor: '直营商',
            service: '服务商',
            consumer: '消费者',
            serviceprovider: '服务人员',

            other: '其他',
        },

        qrcoderegister: {
            scan_desc: '扫一扫二维码图案,成为',
            retailer_name: '零售商',
            dealer_name: "分销商",
            download: '下载',
            user: '扫一扫二维码图案,加入企业',
            copy: '点击复制链接',
            copysuccess: '复制成功',
            copyfail: '复制失败'

        },


        worker: {
            submit_in: '录入员工',
            topsearch: {
                title: '请输入员工手机号查询'
            },
            item: {
                user: '用户名',
                phone: '手机号'
            },
            detail: {
                id: '员工ID',
                name: '真实姓名',
                phone: '手机号',
                delete: '删除员工',

                deletepopup: {
                    title: '确定要删除该员工吗?',
                    confirm: '确定',
                    cancel: '取消'
                }
            }
        },


        // 服务商相关
        serviceprovider: {
            fulladdress: '具体地址',
            belongserviceproviderinfo: '所属服务商',
        },

        // 分销商相关
        distributor: {
            tipsone: '当前上级分销商不存在',
            tipstwo: '当前上级分销商数据解析异常',
            parentinfo: '所属分销商'
        },

        // 零售商相关 
        retailer: {
            tipsone: '所属零售商不存在',
            tipstwo: '所属零售商数据解析异常',

            parentinfo: '所属分销商',
            belongshopinfo: '所属零售商',
        },
        // 供应商商相关 
        supplier: {
            tipsone: '所属供应商不存在',
            tipstwo: '所属供应商数据解析异常',

            parentinfo: '所属供应商',
            item: {
                type: '类型'
            },

            tips: {
                warn: {
                    outboundtargettips: '请先选择出库目标'
                }
            }
        },

        // 直营商相关 
        directvendor: {
            tipsone: '所属直营商不存在',
            tipstwo: '所属直营商数据解析异常',

            parentinfo: '所属直营商',
        },

        loginroleselect: {
            title: '请选择一个身份进行登录',
            desc: '检测到您有多个身份,登录后可切换',
            system_user: '系统用户',
            supplier_user: '供应商',
            distributor_user: '分销商',
            directvendor_user: '直营商',
            retailer_user: '零售商',
            individual_user: '消费者',
            service_provider_user: '服务商',
            service_personnel: '服务人员'

        },



        newstock: {
            create: {
                addToStockDetail: '加入库存汇总',
                clearAllStockDetail: '清空库存汇总',
                createstock: '创建库存',

                addToStockDetailFirst: '请先加入库存汇总',

                serialnumber: ' 序列号',
                enterserialnumber: '请输入序列号',


                tips: {
                    batch_input_tips: '请批量输入序列号,使用换行来分割',
                    input_serialnumber: '请输入序列号',
                    check_all_count: '识别总数量:'

                },

                detail: {
                    gostock: '入库',
                    serialnumberlist: '序列号列表',
                    success: '创建成功',
                    failed: '创建失败',

                    instock_success: '入库成功',
                    no_create_success_stock: '暂无创建成功的库存'
                }

            },

            in: {
                title_unstockin: '待入库',
                title_stockrecord: '入库记录',
                title_querystock: '查看库存',
                scan_stock_in: '扫码入库',
                search_placeholder: '请输入卷号查询',
                in_stock_date: '入库日期',
                un_in_stock_count: '待入库总数',
                in_stock_record_count: '入库记录总数',

                plan_purchase_count: '采购总数',
                real_in_count: '实际入库总数',

                select_purchase_distributor: '请选择上级分销商',
                select_warehouse: '仓库选择',
                confirm_select: '确认选择',
                skip_without_create_warehouse: '跳过(默认主仓)',

                inconfirm: {
                    confirm_in: '确定入库',
                    error_popup: '异常,请重新确定后再入库,其余卷芯号入库成功',
                    error_popup_one: '异常,请重新确定后再入库',
                    error_popup_two: '该产品不在入库范围内,请检查后重新操作',
                    error_popup_three:'某些卷号不在入库范围内,请检查后重新操作',
                    newscan: '重新扫码',
                    in_success: '入库成功',
                    novalid_in: '无效录入',
                },
                stock: {
                    count: '数量:',
                    stock_all_count: '库存总数:',
                    stockin: '已入库',
                    info: '流转信息',
                    instock: '库存中',
                    instock_time: '入库时间',
                    warehouse_name: '仓库全称'
                }
            },
            out: {
                title_unstockout: '待出库',
                title_stockrecord: '出库记录',
                title_querystock: '查看库存',
                search_placeholder: '请输入卷号查询',
                title: '时间:',
                out_stock_time: '出库日期',
                out_stock_time_two: '出库时间',
                out_stock_record_count: '出库记录总数',


                plan_purchase_count: '采购总数',
                real_out_count: '实际出库总数',

                unout: {
                    select_purchase_distributor: '请选择采购分销商/零售商',
                    select_outbount_targetobject: '请选择出库目标',
                    scan_out: '扫码出库',
                    summary_kind_label: '产品种类',
                    summary_kind_unit: '款',
                    summary_pending_label: '待出库合计',
                    no_select_distributor: '请先选择分销商',
                    no_select_targetobject_desc: '请先选择出库目标',
                    search_outbound_target_name: '请输入名称搜索',

                    distributor_un_out_count: '该分销商/零售商待出库数量',

                    targetobject_un_out_count: '该出库目标待出库数量',

                    out_count: '出库数量',
                    plannedpurchase_count: '计划采购数量',

                    out_count_new: '实际出库数量',
                    plannedpurchase_count_new: '采购数量',

                },
                outconfirm: {
                    confirm_in: '确定出库',
                    error_popup: '异常,请重新确定后再出库,其余卷芯号出库成功',
                    error_popup_one: '异常,请重新确定后再出库',
                    error_popup_two: '该产品不在出库范围内,请检查后重新操作',
                    error_popup_three:'某些卷号不在出库范围内,请检查后重新操作',
                    newscan: '重新扫码',
                    in_success: '出库成功',
                    novalid_in: '无效录入',

                },
                unoutdetail: {
                    tag_unout: '待出库',
                    scan_out: '扫码出库',
                    confirm_out: '确定出库',
                    serial: '卷号',
                    check_product_error: '该产品与卷芯号不符,请检查后重新操作',
                    stock_out_success: '出库成功',
                    all: '全部',
                    all_new: '全部商户'

                }


            },
        },


        selectrolepopup: {
            changerole: '切换角色',
            createnewrole: '创建新身份',
            searchplaceholder: '搜索角色类型或公司名称',
            clearsearch: '清除',
            totalroles: '共 {count} 个可选角色',
            noresults: '未找到匹配的角色',
            noresultsdesc: '请尝试其他关键词，例如分销商名称或角色类型',
        },

        qastepform: {
            multi_product_incomplete: '当前有信息未填完整',
            steporigin: {
                stepone: '1.扫码产品信息 -',
                steptwo: '2.填写车辆信息 -',
                stepthree: '3.上传装贴图片 -',
                stepfour: '4.提交完成'
            },


            stepone: {
                scantop: 'Step1扫码产品信息',
                productname: '产品名称',
                serialnumber: '卷号',
                expiredate: '质保时间',
                qacontent: '质保内容',
                retailer: '零售商',
                record_product: '已录入产品',
                delete: '删除',
                next: '继续录入',
                submit: '结束录入\n下一步',
                // rollnumberplaceholder:'若扫码失败,请手动输入卷号',
                rollnumberplaceholder: '请输入卷号',
                rollnumberverify: '验证',
                scanProductInfo: '扫码获取产品信息',
                scanProductInfoError: '(若识别失败,请手动输入卷号验证)',

                popup: {
                    tips_title: '提示',
                    role_not_match_create_qa: '当前账户角色不匹配,无法创建质保',
                    title: '确定要删除该卷芯号吗',
                    confirm: '确定',
                    cancel: '取消',
                    retailer_confirm_title: '确认质保门店',
                    retailer_confirm_lead: '该商品已入库至',
                    retailer_confirm_tail: '，请确认是否在此门店创建质保。',
                    retailer_confirm_yes: '在此门店创建',
                    retailer_confirm_no: '门店不对',
                    retailer_not_match_title: '无法创建质保',
                    retailer_not_match_lead: '该商品已入库至',
                    retailer_not_match_tail: '，与当前门店不一致，无法继续创建质保。如需帮助，请联系该门店或客服。',
                    retailer_not_match_confirm: '我知道了'
                },

                toast: {
                    select_component: '请选择装贴部位',
                    no_repeat_scan: '请勿重复扫卷芯号',
                    roll_number_noempty: '卷号不能为空',
                    rollnumberverify_success: '验证成功',
                    distributor_channel_hint: '该产品属于分销渠道，需要由零售商创建质保，或操作入库才可以创建质保。\n感谢理解！',

                }


            },
            setptwo: {

                scantop: 'Step2填写车辆信息',
                carinfo: '车辆信息',
                carownername: '车主姓名',
                inputcarownername: '请输入车主姓名',
                next: '下一步',
                serialnumber: '卷号',

                toast: {
                    answer_fill_all: '请检查问卷是否填写完整',
                    carownername_fill_all: '请填写车主姓名',
                    phone_fill_all: '请填写手机号',
                    code_fill_all: '请填写验证码',

                    content_check_failed: '请输入正确内容',
                    singlechoice_check_failed: '请选择数据',
                    answer_fill_all_yes: '请检查问卷内容是否填写正确',
                }

            },
            stepthree: {
                scantop: 'Step3上传装贴图片',
                ztimg: '装贴照片',
                serialnumber: '卷号',
                least: '至少',
                most: '最多',
                unit: '张',


                show_below_info: '下方请补充各部件装贴照片特写',


                toast: {
                    success: '创建成功',
                    img_upload_failed: '图片上传数量不符'

                }

            },

            redesign: {
                common: {
                    step_title: '步骤 {step} · {title}',
                    product_progress: '产品 {current} / {total}',
                    product_tab: '产品 {index}',
                    prev_product: '上一个',
                    next_product: '下一个',
                    need_help: '需要帮助？',
                    input_mode_aria: '录入方式',
                    list_separator: '、'
                },
                stepone: {
                    verify_success_label: '卷号验证成功：',
                    task_desc: '手动输入或扫码获取卷号，验证后展示产品信息与部件',
                    manual_input: '手动输入',
                    scan_input: '扫码获取',
                    select_warranty_parts: '选择质保部件',
                    parts_selected: '已选 {selected}/{total}',
                    continue_entry_title: '继续录入产品',
                    entry_title: '录入产品',
                    entry_status_current_total: '正在录入第 {index} 个产品 · 共 {total} 个',
                    entry_status_current: '正在录入第 {index} 个产品'
                },
                steptwo: {
                    task_desc_single: '填写车辆问卷与施工联系信息',
                    task_desc_multi: '每个产品单独填车辆问卷，装贴日期与手机号多产品共用',
                    switch_product_hint: '请使用下方按钮切换产品，完成全部车辆问卷',
                    mount_and_contact: '施工与联系',
                    multi_product_shared: '多产品共用',
                    shared_hint_default: '装贴日期与车主手机号所有产品只需填写一次',
                    shared_hint_zhongsheng: '装贴日期填一次即可',
                    account_phone: '账户手机号',
                    change_phone: '更换手机号',
                    fill_owner_phone: '请填写车主手机号',
                    use_account_phone: '改用账户信息',
                    privacy_dialog_title: '隐私提示',
                    privacy_dialog_message: '由于【中升集团】渠道隐私建议，【车主真实姓名】及【手机号码】建议做保密处理，是否授权填入当前账号的名称【{name}】及手机号码【{phone}】？',
                    privacy_dialog_confirm: '确认授权',
                    privacy_dialog_manual: '手动填写',
                    toast_creator_info_applied: '已使用您的账户信息',
                    toast_account_phone_applied: '已使用账户手机号',
                    toast_no_account_phone: '账户未绑定手机号，请手动填写'
                },
                stepthree: {
                    task_desc_single: '按质保要求上传施工照与部件特写',
                    task_desc_multi: '多产品请分别上传装贴照片，使用下方按钮切换',
                    switch_product_hint: '请使用下方按钮切换产品，完成全部装贴照片',
                    warranty_files_title: '质保文件',
                    warranty_files_desc: '车辆施工与卷号相关照片',
                    component_closeup_title: '部件特写',
                    component_closeup_desc: '各装贴部件近景照片',
                    pending_upload_hint: '产品 {products} 尚有照片待上传'
                }
            }
        },

        qapublicquery: {
            hero_title: '汽车膜质保查询',
            hero_desc: '输入车架号即可查询官方质保信息',
            logo_alt: 'Castrol Auto Films',
            search_card_title: '车架号查询',
            search_card_hint: '请输入完整车架号（VIN）',
            trust_no_login: '免登录',
            trust_instant: '即时查询',
            trust_official: '官方质保',
            guide_phone: '手机号',
            guide_or: '或',
            guide_vin: '车架号',
            guide_result: '查看结果',
            landing_title: '开始查询',
            landing_desc: '输入车架号后点击搜索即可查看质保详情',
            landing_caption: '查询后可查看完整质保信息',
            landing_tap_hint: '点击上方卡片开始',
            landing_preview_code: '质保编号',
            landing_preview_product: '产品名称',
            landing_preview_period: '质保有效期',
            landing_feature_status: '质保状态',
            landing_feature_detail: '产品详情',
            landing_feature_verify: '官方核验',
            empty_title: '未找到质保记录',
            loading: '正在查询，请稍候…',
            result_count: '共 {count} 条质保记录',
            result_found: '已找到质保记录',
            vin_required: '请输入车架号',
            mock_notice: '当前为演示数据，正式接口接入后将展示真实查询结果',
            search_failed: '查询失败，请稍后重试',
            warranty_not_found: '未找到对应质保记录',
            login_guide_title: '需要更多服务？',
            login_guide_desc: '登录后可创建质保、管理订单，使用完整业务功能',
            login_guide_action: '手机号查询',
            create_qa_action: '创建质保',
            float_actions_expand: '展开快捷操作',
            float_actions_collapse: '收起快捷操作',
        },

        qasteplist: {
            topphonesearch: '请输入手机号查询',
            search: {
                hint: '支持手机号或车架号查询',
                vin_hint: '支持车架号查询',
                phone_label: '手机号',
                phone_placeholder: '请输入手机号',
                vin_label: '车架号',
                vin_placeholder: '请输入车架号',
                submit: '搜索',
                reset: '清空',
                require_one: '请至少输入手机号或车架号',
                require_vin: '请输入车架号',
                empty_desc: '暂无匹配的质保记录\n可调整搜索条件后重试',
                edit: '修改'
            },
            list_meta: '共 {count} 条记录',
            list_lead: '查询到的质保记录',
            list_empty_lead: '暂无质保记录',
            tab: {
                all: '全部',
                unapprove: '待生效',
                approved: '已生效',
                rejected: '已驳回'
            },
            item: {
                product: '产品',
                phone: '手机号',
                vin: '车架号',

                unapprove: '待生效',
                approved: '已生效',
                rejected: '已驳回'

            }
        },
        qastepreview: {
            search: '筛选',
            tab: {
                all: '全部',
                unapprove: '待审核',
                approved: '已通过',
                rejected: '已驳回'
            },
            item: {
                product: '产品',
                phone: '手机号',

                unapprove: '待审核',
                approved: '已通过',
                rejected: '已驳回'
            },
            review_success: '审核成功',

        },

        qastepdetail: {
            qastatus: '质保状态',
            carinfo: '车辆信息',
            productname: '产品名称',
            serialnumber: '卷号',
            expireddate: '质保时间',
            qacontent: '质保内容',
            mountparts: '装贴部件',
            qastarttime: '质保开始日期',
            mountinfo:'装贴信息',
            mounttime: '装贴日期',
            retailer: '零售商',
            zt_img: '质保图片',
            review: '审核',

            carownername: '车主姓名',
            carownerphone: '车主手机号',


            unapprove: '待生效',
            approved: '已生效',
            rejected: '已驳回',

            screenshot: {
                save: '保存长截图',
                capturing: '正在生成长截图',
                capturing_hint: '正在整理页面内容，请稍候',
                capturing_slice: '正在拼接第 {current}/{total} 段',
                capturing_saving: '正在保存图片',
                saved: '长截图已保存',
                segmented: '内容较长，已保存 {count} 张分段截图',
                preview_title: '长截图预览',
                preview_hint: '长按图片可保存到相册',
                preview_close: '关闭预览',
                preview_prev: '上一张',
                preview_next: '下一张'
            },

            qrcode: {
                open: '分享',
                hint: '扫码后可查看本质保信息',
                missing_vin: '暂无车架号，无法生成二维码',
                save: '保存到相册',
                save_hint: '长按图片可保存到相册',
                saved: '二维码已保存',
                save_fail: '保存失败，请重试',
                copy_link: '复制链接',
                copy_success: '链接已复制',
                copy_fail: '复制失败，请重试',
                close: '关闭'
            },

            ppf_warranty: {
                detail_title: '质保范围详解',
                detail_link: '详解',
                detail_html: '<h5>非人为因素造成的发污、龟裂、脱胶、雨斑、装贴之前膜面表面有明显瑕疵、黄变、水解均在质保范围之内。</h5><h5>质保范围详解：</h5><ol class="ppf-list"><li>发污是指膜面失去光泽，造成光禿现象；</li><li>龟裂是指膜面脆化，并发生开裂现象；</li><li>脱胶是指在装贴且正常使用的情况下，胶层与膜层产生自动脱离现象；</li><li>雨斑是指雨水在膜面留下非常明显且不可去除的痕迹；</li><li>装贴之前膜面表面有明显瑕疵是指在装贴前，就已发现有且仅有以下情形，即白斑点、明显异物、凝胶、明显斜纹等；</li><li>黄变指膜面明显发黄，轻微黄变属于正常现象，不属于质保范围，即∆E＜2，不承担售后；</li><li>水解是指膜已融化在车漆表面且无法撕除；</li><li>翘边（从施工完交车一个月外翘边在质保内，一月之内算施工技术问题，到店再次包边即可）。</li></ol><h5>备注：</h5><p>因洗车液、柏油清洗剂、柏油、其它化学试剂污染过的车衣膜均不在质保范围内。</p>',
                detail_aria: '查看质保范围详解'
            }

        },



        distributorcoupon: {
            topsearch: {
                content: '请输入手机号查询',
                search: '搜索'
            },
            tabs: {
                all: '全部',
                undo: '未核销',
                done: '已核销'
            },
            phone: '手机号',

            scan: {
                submit: '确认核销',
                scan_success: '核销成功'
            }
        },

        newdealershop: {
            fullname: '商户/公司全称',
            area: '地区',
            address: '地址',
            level: '级别',
            createtime: '创建时间',
            cartype: '证件类型',
            carimg: '证件照片',

        },

        newpurchasedetail: {
            product_info: '产品信息',
            purchase_id: '采购单ID',
            purchase_date: '采购日期',
            purchase_people: '采购人',
            purchase_people_phone: '采购人手机号',

            distributor_info: '分销商信息',

            company_name: '公司名称',
            people_number: '纳税人识别号',
            address: '地址',
            phone: '电话'


        },

        newpurchasemanagerdetail: {
            product_info: '产品信息',
            purchase_id: '采购单ID',
            purchase_date: '采购日期',
            purchase_company: '采购商',
            purchase_people: '采购人',
            purchase_people_phone: '采购人手机号',

        },

        // 交易相关的
        shoporder: {
            orderlist: '交易列表',

            goorder: '购买',

            style: '型号',

            no_sku_price_tips: '暂无价格',

            current_sku_no_price_tips: '当前sku无法下单',

            first_select_address: '请先选择地址',


            create_payment_success: '创建成功',

            go_to_payment: '是否要现在付款?\n若当前未付款,可在订单详情中继续付款',

            payment_create_confirm: '创建',
            payment_create_back: '返回',

            please_retry_select_goods: '当前选择商品暂无价格,请重新选择',


            all_price: '合计',



            search: {
                search_input_order_placeholder: '请输入订单ID查询',
                search_input_payment_placeholder: '请输入付款单ID查询',
            },

            orderitem: {
                orderid: '订单ID',
                channelinfo: '渠道信息',
                orderdate: '下单日期',
                orderperson: '下单人',
                orderphone: '下单人手机号',
                buyerpartytype: '下单主体类型',
                buyerpartyname: '下单主体',
                buy_from: '购买商',


                paymentorderid: '付款单ID',
                paymentorderbuyertype: '付款主体类型',
                paymentorderbuyername: '付款主体',
                createorderdate: '创建日期',
                paymentorderdate: '付款日期',
                confirmorderdate: '确认日期',
                paymentorderinfo: '付款单信息',



                orderamount: '订单金额',
                orderaddress: '地址',

                changestatus: '修改状态',


                statusscuess: '状态更新成功',



                change_status_confirming: '待确认',
                change_status_confirmed: '确认',
                change_status_closed: '关闭',



                payment_method: '付款方式',


                payment_time: '付款时间',
                payment_time_now: '当前时间',
                payment_time_manual: '手动调整',



                id: 'ID',












            },


            orderdetail: {
                gobuy: '创建付款单',
                viewgodetail: '查看发货详情',
                gosend: '去发货',
                sku_amount: 'SKU金额',
                distribution_costs: '配送费用',
                sku_reduce: 'SKU立减',
                discount_amount: '折扣金额',
                really_pay: '实付款',

                channel_title: '渠道信息',
                channel_id: '渠道ID',
                channel_name: '渠道名称',
                channel_type: '渠道类型',
                buyer_title: '买方信息',
                buyer_title_order: '下单信息',
                store_title: '店铺信息',
                order_info: '订单信息',
                store_id: '店铺ID',
                store_name: '店铺名称',


                pricedetail: '价格明细',
                paymentmethod: '支付方式',
                orderpayment: '付款单明细',
                watch_bank_info: '查看银行卡信息',
                up_bank_info: '收起',

                createorder: '创建订单',


                padding_pay_amount: '待付款金额',
                padding_confirming_amount: '待确认金额',
                confirmed_amount: '已确认金额',


                paymentamount: '需支付金额',
                createpaytime: '创建时间',


                buyerpartid: '买方ID',
                buyertype: '买方类型',
                buyerstyle: '买方类型',
                buyerpartname: '买方名称',
                buyerpeople: '下单人',
                buyerphonenumber: '下单人手机号',


                buyerpeople_new: '付款人',
                buyerphonenumber_new: '付款人电话',


                order_id: '订单ID',
                order_time: '下单时间',
                order_status: '订单状态',


                formatted: '格式化',
                added: '添加',
                select_full_date: '选择完整时间',

                full_date_year: '年',
                full_date_month: '月',
                full_date_day: '日',
                full_date_hour: '时',
                full_date_minute: '分',
                full_date_second: '秒',
                confirm: '确定',
                cancel: '取消',

                alipay_redirecting: '正在唤起支付宝支付，请稍候…',
                alipay_querying: '正在查询支付结果，请稍候…',
                alipay_success: '支付成功',
                alipay_back: '返回',
                alipay_scan_tip: '请使用支付宝扫码支付',
                alipay_scan_sub: '支付完成后将自动检测',


                buyer_title_order_new: '付款人信息',

                order_info_new: '订单信息',

                buyer_title_new_title: '付款方信息',

                buyerpartid_new: '付款方ID',
                buyerstyle_new: '付款方类型',
                buyerpartname_new: '付款方名称',
                buyerpeople_new: '付款人',
                buyerphonenumber_new: '付款人电话',


                transactionNo_detail: '交易流水号',
                enter_transactionNo: '请输入交易流水号',
                confirm_date: '确认时间',



                payment_date: '付款时间',




            },

            ordermanager: {
                tab: {
                    all: '全部',
                    unpay: '待付款',
                    unconfirmed: '待确认',
                    partpay: '部分确认',
                    payed: '已确认',
                    closed: '已关闭',
                }

            },

            stockout: {
                //出库的一些提示
                totalQty: '总数量',
                pendingOutboundQty: '待出库数量',
                pendingInboundQty: '待入库数量',
                inboundQty: '已入库数量',


                outboundtime: '出库时间',
                outboundoperation: '出库说明',
                outboundoperation_placeholder: '请输入出库说明'
            },

            store: {
                storeid: 'ID',
                storename: '名称'
            },



        },


        service: {
            servicecenter: {
                search_input_servicecenter_placeholder: '请输入服务网点名称查询',
                create: '创建服务网点',


                creation: {
                    name: '服务网点名称',
                    workcount: '工位数量',
                    confirm: '确定',

                    confirmcreate: '确定创建',


                    create_success_tips: '服务网点创建成功'

                },
                detail: {
                    name: '服务网点名称',
                    address: '地区',
                    fulladdress: '地址',
                    contractphone: '联系电话',
                    workcount: '工位数量',
                }
            },


            manager: {

                search: {
                    content: '请输入服务名称'
                },
                tab: {
                    all: '全部',
                    not_scheduled: '未预约',
                    scheduled: '已预约',
                    served: '已服务',
                    not_required: '无需服务',

                },
                detail: {
                    amount_all: '共计'
                }


            }

        },

        address: {

            list: {
                search_input_address_placeholder: '请输入地址查询',
                create: '新增地址'

            },
            create: {
                owneraddress: '所在地区',
                fulladdress: '详细地址与门牌号',
                name: '收货人名字',

                saveaddress: '保存地址',

                successtips: '地址创建成功'

            },
            detail: {
                country: '国家/地区',
                fulladdress: '详细地址',
                recipientName: '收货人姓名',
                phone: '手机号'
            }

        },

        warehouse: {

            list: {
                search_input_address_placeholder: '请输入仓库名称查询',
                create: '新增仓库'

            },
            create: {
                owneraddress: '所在地区',
                fulladdress: '详细地址与门牌号',
                name: '仓库全称',

                savewarehouse: '保存仓库',

                successtips: '仓库创建成功'
            },
            detail: {
                first_select_warehouse: '请先选择仓库',
                verify: '校验',
                confirm: '确定'
            }

        },


        storemanager: {
            detail: {
                fullname: '店铺名称',
                salesStatus: '售卖状态',
                shoplogo: '店铺logo'


            }
        },


        charts: {
            qachart: {
                name: '质保报表'
            },
            purchasechart: {
                name: '采购报表'
            },
            inoutstockchart: {
                name: '出入库报表'
            }
        },

        apptheme: {
            themesystem: '背景方案切换',

        },















        errorinfopopup: {
            title: '异常信息',
            detail: '详情',
            close: '关闭',


        },

        logout: {
            title: '确定要退出登录吗',
            confirm: '确定',
            cancel: '取消'
        },




        docker: {
            website: '首页',
            main: '地图',
            scheme: '方案',
            mine: '我的'
        }
    }
};